import {Pinia} from 'pinia'
import {useCacheStore} from '@toolify/client/src/stores/CacheStore/useCacheStore'
import {useWorkspaceApiStore} from '@toolify/client/src/stores/api/WorkspaceApiStore/useWorkspaceApiStore'
import {usePermissionApiStore} from '@toolify/client/src/stores/api/PermissionApiStore/usePermissionApiStore'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {
  IWorkspaceResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IWorkspaceResponseInstance'
import {
  IGetUserPermissionsByResourceRequestInterfaces,
} from '@toolify/server/src/controllers/PermissionController/validators/GetUserPermissionsByResource/types/IGetUserPermissionsByResourceRequestInterfaces'

export interface IWorkspaceAccess {
  workspace: IWorkspaceResponseInstance
  permissions: IGetUserPermissionsByResourceRequestInterfaces['response']['permissions']
}

export async function getWorkspaceAccessByName(workspaceName: string, pinia?: Pinia): Promise<IWorkspaceAccess> {
  const cacheStore = useCacheStore(pinia)
  let workspace = cacheStore.getCacheItem<IWorkspaceResponseInstance>(`workspace-by-name-${workspaceName}`)
  if(!workspace) {
    const response = await useWorkspaceApiStore(pinia).getWorkspaceByName(workspaceName)
    cacheStore.setCacheItem(`workspace-by-name-${workspaceName}`, response.workspace)
    workspace = response.workspace
  }
  const {permissions} = await usePermissionApiStore(pinia).getUserPermissionMapByResource(
    ResourceType.Workspace,
    workspace.id,
  )
  return {
    workspace,
    permissions,
  }
}
